<template>
  <div class="bf">
    <div class="top page_bg plr20 pt20">
      <!-- <div class="plr20 pt20 pb20 bgfff b_r_10">
				<div class="mb10">xiangm</div>
				<div>2022</div>
			</div> -->
      <div class="flex_center top-btn">
        <div :class="handleClick == 0 ? 'main_bg cf' : ''" @click="handle(0)">
          待确认
        </div>
        <div :class="handleClick == 1 ? 'main_bg cf' : ''" @click="handle(1)">
          已确认
        </div>
        <div :class="handleClick == 2 ? 'main_bg cf' : ''" @click="handle(2)">
          请假
        </div>
        <div :class="handleClick == 3 ? 'main_bg cf' : ''" @click="handle(3)">
          未签到
        </div>
      </div>
    </div>
    <div class="list plr20" style="padding-bottom: 80px;">
      <div
        class="pt10 pb10 b_r_10 mb20 bgfff"
        style="box-sizing: border-box;"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="flex_items flex_between plr20 l1 w100" style="box-sizing: border-box;">
          <div class="flex flex_items">
            <div
              class="circle mr10"
              :class="item.check ? 'allCheck' : ''"
              v-if="handleClick == 0"
              @click="checkS(item)"
            >
              <div class="circle-c" :class="item.check ? 'main_bg' : ''"></div>
            </div>
            {{ item.name }}
            <div class="main_color mf ml10" v-if="handleClick <= 1">
              {{
                item.time == "forenoon"
                  ? "上午"
                  : item.time == "afternoon"
                  ? "下午"
                  : ""
              }}已签到
            </div>
          </div>

          <div :class="handleClick == 2 ? 'blue' : 'red'">
            <span v-if="handleClick > 1">{{
              item.time == "forenoon"
                ? "上午"
                : item.time == "afternoon"
                ? "下午"
                : ""
            }}</span
            >{{
              handleClick == 0
                ? "待确认"
                : handleClick == 1
                ? "已确认"
                : handleClick == 2
                ? "请假"
                : "未签到"
            }}
          </div>
        </div>
        <div v-if="item.sign.remark2" class="plr20 mt10">备注：{{item.sign.remark2}}</div>
      </div>
      <div class="empty" v-if="list.length == 0">
        暂无数据
      </div>
    </div>
    <div
      class="bottom bgfff plr20 flex flex_items flex_between"
      v-if="handleClick == 0"
    >
      <div class="flex flex_items">
        <div
          class="circle mr10"
          :class="allCheck ? 'allCheck' : ''"
          @click="allCheck = !allCheck"
          v-if="handleClick == 0"
        >
          <div class="circle-c" :class="allCheck ? 'main_bg' : ''"></div>
        </div>
        全选
      </div>
      <div class="btn main_bg cf" @click="show = true">
        确定
      </div>
    </div>

    <Popup v-model="show">
      <div class="bgfff pop-content b_r_10 plr20 pos">
        <van-icon
          name="cross"
          class="pop-close"
          size="30"
          @click="show = false"
        />
        <div class="txt_center pt20 mb20">备注</div>
        <div class="flex flex_items mb10 pb10 bor_b">
          <div style="width: 80px;">备注</div>
          <input
            type="text"
            v-model="bz"
            style="width: 180px;height: 40px;"
            placeholder="请输入备注"
          />
        </div>
        <div class="flex">
          <div
            class="pop-btn main_bg b_r_10"
            style="background:#fff;color:#222;border:1px solid #222"
            @click="cancelFn"
          >
            取消
          </div>
          <div
            class="pop-btn main_bg b_r_10"
            style="margin-left:10px"
            @click="submit"
          >
            确认
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { Popup } from "vant";
import { Dialog } from "vant";
export default {
  components: {
    Popup,
  },
  data() {
    return {
      detail: {},
      id: 1,
      allList: [],
      list: [],
      handleClick: 0,
      allCheck: false,
      flag: true,
      show: false,
      bz: "",
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getList();
  },
  watch: {
    allCheck(n) {
      this.list.map((r) => {
        r.check = n;
      });
      this.$forceUpdate();
    },
  },
  methods: {
    cancelFn() {
      this.show = false;
      this.bz = "";
    },
    checkS(item) {
      if (item.check) {
        item.check = false;
      } else {
        item.check = true;
      }

      this.$forceUpdate();
    },
    handle(t) {
      this.handleClick = t;
      this.serList();
    },
    getList() {
      this.api.confirmUsers({}, this.id).then((res) => {
        this.allList = res.data;
        this.allList.map((r) => {
          if (r.sign) {
            r.status = r.sign.is_sign ? 1 : "";
            if (r.sign.is_sign) {
              //是否已签到
              //签到是否已确认
              if (r.sign.sign_confirm) {
                r.status = 1;
              } else {
                r.status = 2;
              }
            } else {
              //未签到
              if (r.sign.is_leave) {
                //是否已请假
                r.status = 3;
              } else {
                r.status = 0;
              }
            }
          } else {
            r.status = 0;
          }
          r.check = false;
          this.allCheck = false;
        });
        this.serList();
      });
    },
    serList() {
      let l = JSON.parse(JSON.stringify(this.allList));
      this.list = [];
      let arr = [];
      let i =
        this.handleClick == 3
          ? 0
          : this.handleClick == 2
          ? 3
          : this.handleClick == 1
          ? 1
          : 2;
      l.map((r) => {
        if (r.status == i) {
          arr.push(r);
        }
      });
      this.list = arr;
    },
    submit() {
      if (this.list.length == 0) {
        this.Toast("暂无需要确认到场的会员");
        return;
      }
      let arr = [];
      this.list.map((r) => {
        if (r.check) {
          arr.push(r.sign.id);
        }
      });
      if (arr.length == 0) {
        this.Toast("请选择确认到场的会员");
        return;
      }
      if (!this.flag) {
        return;
      }
      this.flag = false;

      Dialog.confirm({
        title: "确认",
        message: "确认所选会员都已到场？",
      })
        .then(() => {
          this.api
            .confirm(
              {
                signs: JSON.stringify(arr),
                remark2: this.bz,
              },
              this.id
            )
            .then((res) => {
              this.Toast("操作成功");
              this.getList();
              this.flag = true;
              this.show = false;
              this.bz = "";
            })
            .catch(() => {
              this.flag = true;
              this.show = false;
              this.bz = "";
            });
        })
        .catch(() => {
          // on cancel
          this.show = false;
          this.flag = true;
        });
    },
  },
};
</script>

<style scoped="scoped">
.top {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  box-sizing: border-box;
}

.list {
  padding-top: 80px;
}

/* .top-btn{
		height: 75px;
	} */
.top-btn div {
  width: 90px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-radius: 10px;
}

.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70px;
  z-index: 2;
  border-top: 1px solid #ccc;
  box-sizing: border-box;
}

.circle {
  border-radius: 50%;
  width: 27px;
  height: 27px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle.allCheck {
  border: 1px solid #00d8cc;
}

.circle-c {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.btn {
  width: 100px;
  height: 50px;
  border-radius: 5px;
  text-align: center;
  line-height: 50px;
}
.bg_blue {
  background-color: #c2e1ff;
  color: #3399ff;
}
.y_bg {
  background-color: #fff0d1;
  color: #ff9966;
}
.gr_bg {
  color: #00d8cc;
  background-color: #d1f0e1;
}
.pop-content {
  width: 300px;
  height: 200px;
  box-sizing: border-box;
}

.pop-btn {
  width: 250px;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  height: 40px;
  line-height: 40px;
}

.pop-close {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
